import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import CmsElementQuestionnaireForm from './CmsElementQuestionnaireForm';
import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementQuestionnaire extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const mainColorClass = 'text-' + this.getParamValue('mainColor', 'master') + ' ';
    const questionnaireId = this.getParamValue('questionnaireId');
    const pipelineId = this.getParamValue('pipelineId');
    const successMessage = this.getParamValue('thankYouText');
    const buttonTitle = this.getParamValue('buttonTitle');
    const leadSource = this.getParamValue('leadSource');

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={
          'ms-questionnaire-content ' + shownClass + mainColorClass + this.getResponsiveClasses() + this.getCssClasses()
        }
        style={{ ...this.getBackgroundStyle() }}
      >
        {this.getElementStyle()}

        {!!questionnaireId && (
          <React.Fragment>
            <h4 className={'no-margin p-b-5 ' + mainColorClass}>{this.getParamValue('title', messages.questionnaire)}</h4>

            <CmsElementQuestionnaireForm
              questionnaireId={questionnaireId}
              pipelineId={pipelineId}
              mainColorClass={mainColorClass}
              successMessage={successMessage}
              buttonTitle={buttonTitle}
              leadSource={leadSource}
            />
          </React.Fragment>
        )}

        {this.getAppendHtml()}
      </div>
    );

    return (
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>

      </div>
    );
  }
}
CmsElementQuestionnaire.defaultProps = {
  index: '0',
};
